import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import PageBanner from '../../../../common/components/PageBanner';
import EventCard from '../../../../common/components/EventCard';
import { getUpcomingEvents } from '../../../../content/events';
import banner from '../../../../assets/new-images/banner_4_events-calendar_cropped.png';
import "../styles/Aboutus.css"

const PAGE_SIZE = 6;

const OurEventsComponent = () => {
  const upcoming = useMemo(() => getUpcomingEvents(), []);
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return upcoming;
    return upcoming.filter((e) =>
      [e.title, e.host, e.location].some((field) => field.toLowerCase().includes(q))
    );
  }, [upcoming, query]);

  const pageCount = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const shown = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <div>
      <PageBanner
        image={banner}
        fade
        alt="A community emergency-preparedness training event with attendees and MYREDFOLDER plan folders."
        eyebrow="About Us / Events"
        title="Events Calendar"
      />

      {upcoming.length === 0 ? (
        <section className="mrf-empty">
          <h2 className="mrf-heading">No upcoming sessions</h2>
          <p className="mrf-lead">
            No upcoming sessions are posted right now. Explore our preparedness resources or subscribe for updates.
          </p>
          <div className="mrf-empty__actions">
            <Link className="mrf-btn mrf-btn--primary" to="/knowledgeBase/risk-by-location">Explore preparedness resources</Link>
            <Link className="mrf-btn mrf-btn--secondary" to="/knowledgeBase/newsletter">Subscribe for updates</Link>
          </div>
        </section>
      ) : (
        <section className="mrf-section">
          <div className="mrf-container">
            <label htmlFor="event-search" className="mrf-body" style={{ display: "block", fontWeight: 500, color: "#1f2430" }}>
              Search events by name, host, or location
            </label>
            <input
              id="event-search"
              type="search"
              value={query}
              onChange={(e) => { setQuery(e.target.value); setPage(1); }}
              placeholder="e.g. Online, Orlando, NEPTA"
              style={{ width: "100%", maxWidth: 520, minHeight: 48, padding: "10px 14px", border: "1px solid #bcbcbc", borderRadius: 6, fontSize: 16 }}
            />
            <p className="mrf-body" role="status" style={{ marginTop: 16 }}>
              {filtered.length === 0
                ? "No events match your search."
                : `Showing ${(page - 1) * PAGE_SIZE + 1}–${Math.min(page * PAGE_SIZE, filtered.length)} of ${filtered.length} events`}
            </p>
            <div className="mrf-grid-3" style={{ marginTop: 16 }}>
              {shown.map((event) => (
                <EventCard key={`${event.title}-${event.startDate}`} event={event} headingLevel="h2" />
              ))}
            </div>
            {pageCount > 1 && (
              <nav aria-label="Event pages" style={{ display: "flex", gap: 8, justifyContent: "center", marginTop: 32 }}>
                {Array.from({ length: pageCount }, (_, i) => i + 1).map((n) => (
                  <button
                    key={n}
                    type="button"
                    className={`mrf-btn ${n === page ? "mrf-btn--primary" : "mrf-btn--secondary"}`}
                    aria-current={n === page ? "page" : undefined}
                    onClick={() => setPage(n)}
                    style={{ minWidth: 48 }}
                  >
                    {n}
                  </button>
                ))}
              </nav>
            )}
          </div>
        </section>
      )}
    </div>
  )
}

export default OurEventsComponent
